import isoCountries from 'i18n-iso-countries'

/**
 * ISO 3166-2 country code validation
 */
export const isValidCountryCode = (value: string): boolean => {
  return isoCountries.isValid(value.toLowerCase()) && value.length === 2
}
